import { performIssuePutRequest } from '@atlassian/jira-issue-reliability-fetch/src/index.tsx';

type IssueKey = string;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getFieldUpdate = (fieldKey: string, value: any) => ({
	fields: {
		[fieldKey]: value,
	},
});

export const defaultSaveField = async <T,>(issueKey: IssueKey, fieldKey: string, newValue: T) =>
	performIssuePutRequest(
		`/rest/api/3/issue/${issueKey}/`,
		{
			body: JSON.stringify(getFieldUpdate(fieldKey, newValue)),
		},
		'fields/field-base/src/services/edit-field-service/utils',
	);

/**
 * Performes PUT request to update the issue fields and returns full shape of updated data.
 * It uses `returnIssue` query param to enable the non empty response.
 */
export const defaultSaveFieldById = async <T,>(issueKey: IssueKey, fieldKey: string, newValue: T) =>
	performIssuePutRequest(
		`/rest/api/3/issue/${issueKey}/?returnIssue=true`,
		{
			body: JSON.stringify(getFieldUpdate(fieldKey, newValue)),
		},
		'fields/field-base/src/services/edit-field-service/utils',
	);

export const defaultAddValuesToField = async <T,>(
	issueKey: IssueKey,
	fieldKey: string,
	valuesToAdd: T,
) => {
	const updateParam = {
		update: {
			[fieldKey]: [
				{
					operation: 'add',
					value: valuesToAdd,
				},
			],
		},
	};
	return performIssuePutRequest(
		`/rest/api/3/issue/${issueKey}/`,
		{
			body: JSON.stringify(updateParam),
		},
		'fields/field-base/src/services/edit-field-service/utils',
	);
};

export const defaultRemoveValuesFromField = async <T,>(
	issueKey: IssueKey,
	fieldKey: string,
	valuesToRemove: T,
) => {
	const updateParam = {
		update: {
			[fieldKey]: [
				{
					operation: 'remove',
					value: valuesToRemove,
				},
			],
		},
	};
	return performIssuePutRequest(
		`/rest/api/3/issue/${issueKey}/`,
		{
			body: JSON.stringify(updateParam),
		},
		'fields/field-base/src/services/edit-field-service/utils',
	);
};
